import { dataHooks } from '@wix/data-hooks'

export const wixMobileDomainNFDataHooks = dataHooks<{
  title: {}
  subtitle: {}
  input: {}
  next: {}
  skip: {}
  successMessage: {}
  domainBanner: {}
}>('wix-mobile-domain-nf')
